__turbopack_context__.v({
  "actions": "about-module__eMI3ga__actions",
  "button": "about-module__eMI3ga__button",
  "chapter": "about-module__eMI3ga__chapter",
  "chapters": "about-module__eMI3ga__chapters",
  "container": "about-module__eMI3ga__container",
  "founder": "about-module__eMI3ga__founder",
  "founders": "about-module__eMI3ga__founders",
  "intro": "about-module__eMI3ga__intro",
  "invitation": "about-module__eMI3ga__invitation",
  "lead": "about-module__eMI3ga__lead",
  "name": "about-module__eMI3ga__name",
  "opening": "about-module__eMI3ga__opening",
  "page": "about-module__eMI3ga__page",
  "portrait": "about-module__eMI3ga__portrait",
  "role": "about-module__eMI3ga__role",
  "sidebar": "about-module__eMI3ga__sidebar",
  "statement": "about-module__eMI3ga__statement",
  "story": "about-module__eMI3ga__story",
  "storyLayout": "about-module__eMI3ga__storyLayout",
  "subtitle": "about-module__eMI3ga__subtitle",
  "textLink": "about-module__eMI3ga__textLink",
  "title": "about-module__eMI3ga__title",
});
